import React, { useState, Fragment } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';

import { FeedbackForm } from '../../../../util/appConstants';
import { RadioButtonMark } from 'components/Checkbox/Checkbox';
import { Button } from '../../../components';
import {
  OptionsContainer,
  OptionAndLabelContainer,
  Question,
  OptionLabel,
  CommentTextArea,
  CloseButton,
} from './styles';
import './style.css';

export default React.memo((props) => {
  const [isOpen, setIsOpen] = useState(true);
  const [feedbackForm, setFeedbackForm] = useState([
    {
      question: FeedbackForm[0].question,
      review: '',
    },
    {
      question: FeedbackForm[1].question,
      review: '',
    },
    {
      question: FeedbackForm[2].question,
      review: '',
    },
    {
      comment: '',
    },
  ]);

  const submitForm = (value) => {
    setIsOpen(true);
    return props.confirm(feedbackForm, value);
  };

  return (
    <Modal isOpen={isOpen} className="modal-container">
      <ModalHeader className="feedback-modal-title">
        We value your feedback!
        <br />
        {props.test}
      </ModalHeader>
      <CloseButton onClick={() => submitForm(false)}>&times;</CloseButton>
      <Form onSubmit={() => submitForm(true)}>
        <ModalBody className="feedback-modal-body">
          {FeedbackForm.map((feedback, index) => {
            return (
              <Fragment key={index}>
                <Question>{feedback.question}</Question>
                <OptionsContainer>
                  {feedback.options.map((option, i) => {
                    return (
                      <OptionAndLabelContainer
                        key={i}
                        onClick={() =>
                          setFeedbackForm((form) =>
                            Object.assign([], form, { [index]: { ...form[index], review: option } })
                          )
                        }
                      >
                        <RadioButtonMark checked={feedbackForm[index]['review'] === option} />
                        <OptionLabel>{option}</OptionLabel>
                      </OptionAndLabelContainer>
                    );
                  })}
                </OptionsContainer>
              </Fragment>
            );
          })}
          <Question>General comment for us:</Question>
          <CommentTextArea
            rows="4"
            placeholder="Write comment for us"
            onChange={(e) => setFeedbackForm((form) => Object.assign([], form, { 3: { comment: e.target.value } }))}
          ></CommentTextArea>
        </ModalBody>
        <ModalFooter>
          <Button small primaryBlue primaryGreenBorder removeMargin>
            Submit
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
});
